import { InvestmentAccountType } from '@egw/api'
import { useTranslation } from '@egw/i18n'
import { InformationCircleIcon } from '@heroicons/react/20/solid'
import { type FC, useMemo } from 'react'
import { useTransferContextProvider } from '../../context'
import { type TransferListOption } from '../../types'

export const SettlementAlert: FC = () => {
  const { t } = useTranslation('features-transfer')

  const { fromFieldOption } = useTransferContextProvider() as { fromFieldOption: TransferListOption | null }

  const showAlert = useMemo(
    () =>
      fromFieldOption?.accountType === InvestmentAccountType.BROKERAGE ||
      fromFieldOption?.accountType === InvestmentAccountType.JOINT_BROKERAGE_TIC ||
      fromFieldOption?.accountType === InvestmentAccountType.JOINT_BROKERAGE_JTWROS,
    [fromFieldOption],
  )

  return showAlert ? (
    <div className="flex w-full items-start justify-start py-2 px-3 rounded-sm bg-alertInfoBg">
      <div className="flex h-full w-full flex-row items-start gap-2">
        <div className="py-[0.15rem]">
          <InformationCircleIcon className="fill-alertInfoIconFill w-4 h-4" />
        </div>
        <p
          className="flex-grow text-sm text-alertInfoText"
          id="market_settlement_disclaimer"
          data-testid="market_settlement_disclaimer"
        >
          {t('transfer.market_settlement_disclaimer')}
        </p>
      </div>
    </div>
  ) : null
}
